import { Controller } from "@hotwired/stimulus"

// Submits the locale form when the language select changes.
export default class extends Controller {
  submit(event) {
    event.target.form.requestSubmit()
  }
}
